<template>
  <v-container id="attendance-list">
    <v-btn
      type="button"
      color="primary"
      style="margin-left: 10px"
      @click="goBack()"
    >
      Voltar
    </v-btn>
    <v-card class="mt-6 rounded-0">
      <v-card>
        <v-btn
          class="rela"
          style="max-width: none"
          @click="gerarRelatorio('relatorio')"
        >
          <span> <v-icon>mdi-file-excel</v-icon> Relatório </span>
        </v-btn>
        <v-btn
          class="rela"
          style="max-width: none"
          @click="gerarRelatorio('oportunidade')"
        >
          <span>
            <v-icon>mdi-file-excel</v-icon>Relatório de Oportunidades
          </span>
        </v-btn>
      </v-card>
      <v-bottom-navigation color="primary" class="w-100">
        <v-btn
          :to="
            '/cidade/' + payload.municipioId + '/agenteTerritorial/' + tab.id
          "
          v-for="tab in tabs"
          :key="tab.id"
          class="flex-grow-1"
          style="max-width: none"
          @click="tabName = tab.id"
        >
          <span>{{ tab.name }}</span>
        </v-btn>
      </v-bottom-navigation>
    </v-card>
    <v-card v-for="tab in tabs" :key="tab.id" class="rounded-0 bg-light inside">
      <div v-if="tabName === tab.id" class="container-border">
        <component v-bind:is="dinamicyComponent(tab.component)"></component>
      </div>
    </v-card>
  </v-container>
</template>
<script>
import { relatoriosApi } from "./Api/relatorios";
import { criarLinkRelatorio } from "@/helpers/gerarRelatorio";
import { mapActions } from "vuex";
import moment from "moment";

const tabsComponent = {
  Atores: () => import("./atores/list"),
  Vocacao: () => import("./vocacao/list"),
  Potenciais: () => import("./potencial/list"),
  Governanca: () => import("./governanca/list"),
  RecursosFinanceiro: () => import("./recursosFinanceiros/list"),
  OutrasOportunidades: () => import("./outrasOportunidades/list"),
  MarcoLegal: () => import("./marcoLegal/list"),
};

export default {
  data() {
    return {
      tabs: [
        { id: "ator", name: "Atores", component: "Atores" },
        // { id: "vocacao", name: "Vocações", component: "Vocacao" },
        // { id: "potenciais", name: "Potenciais", component: "Potenciais" },
        {
          id: "marco",
          name: "Marcos Legais",
          component: "MarcoLegal",
        },
        { id: "governanca", name: "Governança", component: "Governanca" },
        {
          id: "recurso",
          name: "Recursos Financeiros",
          component: "RecursosFinanceiro",
        },
        {
          id: "outras",
          name: "Oportunidades",
          component: "OutrasOportunidades",
        },
      ],
      payload: {
        municipioId: this.$route.params.id,
      },
      tabName: this.$route.params.tab,
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    dinamicyComponent(tab) {
      return tabsComponent[tab];
    },
    gerarRelatorio(tipo) {
      this.setLoading(true);
      if (tipo === "oportunidade") {
        relatoriosApi
          .oportunidade(this.payload.municipioId)
          .then((resp) => {
            this.setLoading(false);
            const nome = `Relatório de Oportunidades - ${moment().format(
              "DD_MM_YYYY_HH_mm"
            )}`;
            criarLinkRelatorio(resp.data, nome);
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao gerar eXcel");
          });
      } else {
        relatoriosApi
          .agenteTerritorial(this.payload.municipioId)
          .then((resp) => {
            this.setLoading(false);
            const nome = `Relatório de Agente Territorial - ${moment().format(
              "DD_MM_YYYY_HH_mm"
            )}`;

            criarLinkRelatorio(resp.data, nome);
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao gerar eXcel");
          });
      }
    },
    goBack() {
      this.$router.push(`/cidade/${this.payload.municipioId}`);
    },
  },
};
</script>
<style scoped lang="scss">
.v-btn--active {
  background: var(--corPrimaria) !important;
  color: #fff !important;
}

.container-border {
  border: 4px solid var(--corPrimaria);
}

.rela {
  margin-right: 10px;
  i {
    color: green !important;
  }
}
</style>
